export const iconFontAwesomeDesignLinesLeaning = (
	<i className="fa-solid fa-lines-leaning"></i>
);
